<template>
  <div class="min-h-screen bg-neutral-50 pt-8 pb-16">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <!-- 个人信息卡片 -->
      <div
        class="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 md:p-8 mb-8 flex flex-col md:flex-row items-center md:items-start gap-6 relative overflow-hidden"
      >
        <!-- 背景装饰 -->
        <div
          class="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none"
        ></div>

        <!-- 头像 -->
        <div class="relative group">
          <img
            :src="user.avatar"
            alt="用户头像"
            class="w-24 h-24 md:w-32 md:h-32 rounded-full object-cover border-4 border-white shadow-md"
          />
          <button
            @click="triggerAvatarUpload"
            class="absolute bottom-0 right-0 w-8 h-8 bg-white rounded-full shadow border border-neutral-200 flex items-center justify-center text-neutral-600 hover:text-primary transition-colors"
          >
            <i class="fa fa-camera text-xs"></i>
          </button>
          <!-- 隐藏的文件选择器 -->
          <input
            ref="avatarInput"
            type="file"
            accept="image/png, image/jpeg, image/jpg, image/webp"
            class="hidden"
            @change="handleAvatarUpload"
          />
        </div>

        <!-- 信息 -->
        <div class="flex-1 text-center md:text-left z-10">
          <div
            class="flex flex-col md:flex-row items-center md:items-baseline gap-3 mb-2"
          >
            <h1 class="text-2xl font-bold text-neutral-900">
              {{ user.name }}
            </h1>
            <span
              class="px-2 py-0.5 bg-yellow-100 text-yellow-700 text-xs font-medium rounded-full border border-yellow-200"
            >
              <i class="fa fa-star mr-1"></i>Lv.3 资深创作者
            </span>
          </div>
          <p class="text-neutral-500 text-sm mb-4">
            <!-- 加入时间：{{ state.user.joinDate }} -->
          </p>
          <div class="flex flex-wrap justify-center md:justify-start gap-2">
            <span
              class="px-3 py-1 bg-neutral-100 rounded-full text-xs text-neutral-600"
              >AI 爱好者</span
            >
            <!-- <span
              class="px-3 py-1 bg-neutral-100 rounded-full text-xs text-neutral-600"
              >全栈开发</span
            > -->
            <button
              class="w-6 h-6 rounded-full border border-neutral-300 flex items-center justify-center text-neutral-400 hover:border-primary hover:text-primary transition-colors text-xs"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <!-- 数据概览 -->
        <div class="flex gap-4 md:gap-8 mt-4 md:mt-0 z-10">
          <div class="text-center">
            <div class="text-2xl font-bold text-neutral-900">
              {{ user.points }}
            </div>
            <div class="text-xs text-neutral-500">积分</div>
          </div>
          <div class="w-px bg-neutral-200 h-10 self-center"></div>
          <div class="text-center">
            <div class="text-2xl font-bold text-neutral-900">
              {{ myToolList.length }}
            </div>
            <div class="text-xs text-neutral-500">发布</div>
          </div>
          <div class="w-px bg-neutral-200 h-10 self-center"></div>
          <div class="text-center">
            <div class="text-2xl font-bold text-neutral-900">
              <!-- {{ user.favorites.length }} -->
              {{ favTotal }}
            </div>
            <div class="text-xs text-neutral-500">收藏</div>
          </div>
        </div>

        <!-- 编辑按钮 -->
        <!-- <button
          class="absolute top-6 right-6 text-neutral-400 hover:text-primary transition-colors md:block hidden"
        >
          <i class="fa fa-cog text-xl"></i>
        </button> -->
      </div>

      <!-- 主要内容区 -->
      <div class="flex flex-col lg:flex-row gap-8">
        <!-- 左侧导航 -->
        <div class="w-full lg:w-64 flex-shrink-0">
          <div
            class="bg-white rounded-xl shadow-sm border border-neutral-200 overflow-hidden sticky top-24"
          >
            <nav class="flex flex-col p-2">
              <button
                v-for="tab in tabs"
                :key="tab.id"
                @click="selectTab(tab.id)"
                :class="[
                  'flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-all mb-1',
                  currentTab === tab.id
                    ? 'bg-primary/10 text-primary'
                    : 'text-neutral-600 hover:bg-neutral-50',
                ]"
              >
                <i :class="['fa w-6 text-center mr-2', tab.icon]"></i>
                {{ tab.name }}
              </button>
            </nav>
            <div class="border-t border-neutral-100 p-2 mt-2">
              <button
                @click="logout"
                class="w-full flex items-center px-4 py-3 rounded-lg text-sm font-medium text-red-500 hover:bg-red-50 transition-all"
              >
                <i class="fa fa-sign-out w-6 text-center mr-2"></i>
                退出登录
              </button>
            </div>
          </div>
        </div>

        <!-- 右侧内容 -->
        <div class="flex-1 min-w-0">
          <!-- 收藏列表 -->
          <div v-if="currentTab === 'favorites'" class="space-y-6">
            <div class="flex items-center justify-between mb-4">
              <h2 class="text-lg font-bold text-neutral-900">我的收藏</h2>
              <div class="text-sm text-neutral-500">
                共 {{ favTotal }} 个工具
              </div>
            </div>

            <div
              v-if="favToolList.length > 0"
              class="grid grid-cols-1 md:grid-cols-3 gap-4"
            >
              <div
                v-for="tool in favToolList"
                :key="tool.id"
                class="bg-white rounded-xl border border-neutral-200 overflow-hidden hover-lift cursor-pointer group flex flex-col h-full"
                @click="openToolDetail(tool)"
              >
                <div class="h-40 overflow-hidden relative">
                  <img
                    :src="tool.cover"
                    :alt="tool.title"
                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div class="absolute top-2 right-2">
                    <button
                      @click.stop="toggleFavorite(tool.id)"
                      class="w-8 h-8 rounded-full bg-white/90 backdrop-blur text-red-500 flex items-center justify-center hover:bg-white shadow-sm transition-all"
                    >
                      <i class="fa fa-heart"></i>
                    </button>
                  </div>
                </div>
                <div class="p-4 flex-1 flex flex-col">
                  <div class="flex justify-between items-start mb-2">
                    <h3 class="font-bold text-neutral-900 line-clamp-1">
                      {{ tool.title }}
                    </h3>
                    <div
                      class="flex items-center text-xs text-yellow-500 bg-yellow-50 px-1.5 py-0.5 rounded"
                    >
                      <i class="fa fa-star mr-1"></i>{{ tool.rating }}
                    </div>
                  </div>
                  <p class="text-neutral-500 text-xs mb-3 line-clamp-2 flex-1">
                    {{ tool.description }}
                  </p>
                  <div
                    class="flex items-center justify-between text-xs text-neutral-400 mt-auto"
                  >
                    <!-- <span>{{ tool.category_id }}</span> -->
                    <!-- 实际应该显示分类名 -->
                    <span
                      ><i class="fa fa-download mr-1"></i
                      >{{ tool.downloadCount }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="flex justify-end w-full col-span-1 md:col-span-3">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="favTotal"
                  @current-change="pageChange($event, 'favorites')"
                />
              </div>
            </div>

            <div
              v-else
              class="bg-white rounded-xl border border-neutral-200 p-12 text-center"
            >
              <div
                class="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4 text-neutral-400"
              >
                <i class="fa fa-heart-o text-2xl"></i>
              </div>
              <h3 class="text-lg font-medium text-neutral-900 mb-2">
                暂无收藏
              </h3>
              <p class="text-neutral-500 text-sm mb-6">
                你还没有收藏任何工具，去探索一下吧！
              </p>
              <router-link
                to="/explore"
                class="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
              >
                探索工具
              </router-link>
            </div>
          </div>

          <!-- 发布列表 -->
          <div v-else-if="currentTab === 'submissions'" class="space-y-6">
            <div class="flex items-center justify-between mb-4">
              <h2 class="text-lg font-bold text-neutral-900">我的发布</h2>
              <div
                @click="checkLogin('/submit')"
                class="text-sm text-primary hover:underline font-medium cursor-pointer"
              >
                <i class="fa fa-plus mr-1"></i>发布新工具
              </div>
            </div>

            <div v-if="myToolList.length > 0" class="space-y-4">
              <div
                v-for="tool in myToolList"
                :key="tool.id"
                class="bg-white rounded-xl border border-neutral-200 p-4 flex items-center hover-lift cursor-pointer group"
                @click="openToolDetail(tool)"
              >
                <img
                  :src="tool.cover"
                  class="w-16 h-16 rounded-lg object-cover bg-neutral-100 mr-4"
                />
                <div class="flex-1 min-w-0 mr-4">
                  <div class="flex justify-between">
                    <h3
                      class="font-bold text-neutral-900 mb-1 group-hover:text-primary transition-colors"
                    >
                      {{ tool.title }}
                    </h3>

                    <span
                      class="text-xs px-2 py-1 rounded-full"
                      :class="{
                        'bg-yellow-100 text-yellow-700': tool.status === 0,
                        'bg-green-100 text-green-700': tool.status === 1,
                        'bg-red-100 text-red-700': tool.status === 2,
                      }"
                    >
                      {{ getStatusText(tool.status) }}
                    </span>
                  </div>
                  <div
                    class="flex items-center text-xs text-neutral-500 space-x-3"
                  >
                    <span
                      ><i class="fa fa-calendar mr-1"></i
                      >{{
                        new Date(tool.createTime).format("yyyy-MM-dd")
                      }}</span
                    >
                    <span
                      ><i class="fa fa-download mr-1"></i
                      >{{ tool.download_count }}</span
                    >
                    <span
                      ><i class="fa fa-star mr-1"></i>{{ tool.rating }}</span
                    >
                  </div>
                </div>
                <div class="flex space-x-2">
                  <button
                    class="p-2 text-neutral-400 hover:text-primary transition-colors"
                    title="编辑"
                    @click.stop
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    class="p-2 text-neutral-400 hover:text-red-500 transition-colors"
                    title="删除"
                    @click.stop="deleteTool(tool)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                </div>
              </div>

              <div class="flex justify-end w-full">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="sendTotal"
                  @current-change="pageChange($event, 'submissions')"
                />
              </div>
            </div>
            <div
              v-else
              class="bg-white rounded-xl border border-neutral-200 p-12 text-center"
            >
              <div
                class="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4 text-neutral-400"
              >
                <i class="fa fa-upload text-2xl"></i>
              </div>
              <h3 class="text-lg font-medium text-neutral-900 mb-2">
                暂无发布
              </h3>
              <p class="text-neutral-500 text-sm mb-6">
                分享你的AI工具，让更多人看到！
              </p>
              <router-link
                to="/submit"
                class="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
              >
                立即发布
              </router-link>
            </div>
          </div>

          <!-- 积分记录 -->
          <div v-else-if="currentTab === 'points'" class="space-y-6">
            <div class="flex items-center justify-between mb-4">
              <h2 class="text-lg font-bold text-neutral-900">积分记录</h2>
              <div class="text-sm text-neutral-500">
                当前积分:
                <span class="text-primary font-bold">{{ user.points }}</span>
              </div>
            </div>

            <div
              class="bg-white rounded-xl border border-neutral-200 overflow-hidden"
            >
              <table class="w-full text-sm text-left">
                <thead
                  class="bg-neutral-50 text-neutral-500 border-b border-neutral-200"
                >
                  <tr>
                    <th class="px-6 py-3 font-medium">行为</th>
                    <th class="px-6 py-3 font-medium">变动</th>
                    <th class="px-6 py-3 font-medium text-right">时间</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-neutral-100">
                  <tr
                    v-for="(record, index) in pointRecords"
                    :key="index"
                    class="hover:bg-neutral-50"
                  >
                    <td class="px-6 py-4 text-neutral-900">
                      {{ getPointTitle(record.flowType, record.bizNote) }}
                    </td>
                    <td
                      class="px-6 py-4 font-medium"
                      :class="
                        record.integral > 0 ? 'text-green-600' : 'text-red-600'
                      "
                    >
                      {{ record.integral > 0 ? "+" : "" }}{{ record.integral }}
                    </td>
                    <td class="px-6 py-4 text-neutral-500 text-right">
                      {{
                        new Date(record.createTime).format("yyyy-MM-dd hh:mm")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="flex justify-end w-full">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pointTotal"
                @current-change="pageChange($event, 'points')"
              />
            </div>
          </div>

          <!-- 账号设置 -->
          <div v-else-if="currentTab === 'settings'" class="max-w-2xl mx-auto">
            <h2 class="text-lg font-bold text-neutral-900 mb-6">账号设置</h2>

            <div
              class="bg-white rounded-xl border border-neutral-200 p-6 md:p-8 space-y-6"
            >
              <!-- 基本信息 -->
              <div>
                <h3
                  class="text-sm font-bold text-neutral-900 mb-4 border-b border-neutral-100 pb-2"
                >
                  基本信息
                </h3>
                <div class="space-y-4">
                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >头像</label
                    >
                    <div class="flex items-center space-x-4">
                      <img
                        :src="userInfo.avatar"
                        class="w-16 h-16 rounded-full object-cover border border-neutral-200"
                      />
                      <button
                        @click="triggerAvatarUpload"
                        class="px-4 py-2 border border-neutral-200 rounded-lg text-sm hover:bg-neutral-50 transition-colors"
                      >
                        更换头像
                      </button>
                    </div>
                  </div>

                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >昵称</label
                    >
                    <input
                      type="text"
                      v-model="userInfo.username"
                      class="w-full px-4 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-primary/50 focus:border-primary focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >邮箱</label
                    >
                    <input
                      type="email"
                      v-model="userInfo.email"
                      class="w-full px-4 py-2 rounded-lg border border-neutral-200 bg-neutral-50 text-neutral-500 cursor-not-allowed"
                      readonly
                    />
                  </div>

                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >个人简介</label
                    >
                    <textarea
                      v-model="userInfo.bio"
                      rows="3"
                      class="w-full px-4 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-primary/50 focus:border-primary focus:outline-none"
                      placeholder="介绍一下你自己..."
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- 安全设置 -->
              <div>
                <h3
                  class="text-sm font-bold text-neutral-900 mb-4 border-b border-neutral-100 pb-2 pt-4"
                >
                  安全设置
                </h3>
                <div class="space-y-4">
                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >当前密码</label
                    >
                    <input
                      type="password"
                      v-model="userInfo.currentPassword"
                      class="w-full px-4 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-primary/50 focus:border-primary focus:outline-none"
                      placeholder="如需修改密码请填写"
                    />
                  </div>
                  <div>
                    <label
                      class="block text-sm font-medium text-neutral-700 mb-1"
                      >新密码</label
                    >
                    <input
                      type="password"
                      v-model="userInfo.newPassword"
                      class="w-full px-4 py-2 rounded-lg border border-neutral-200 focus:ring-2 focus:ring-primary/50 focus:border-primary focus:outline-none"
                      placeholder="输入新密码"
                    />
                  </div>
                </div>
              </div>

              <div class="pt-4 border-t border-neutral-100 flex justify-end">
                <button
                  @click="saveSettings"
                  class="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-medium"
                >
                  保存修改
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tools } from "@/data/mock";
import { ElMessageBox, ElMessage } from "element-plus";
import { globalState } from "@/state";

export default {
  name: "UserCenterPage",
  data() {
    return {
      tools: tools,
      currentTab: "favorites",
      tabs: [
        { id: "favorites", name: "我的收藏", icon: "fa-heart" },
        { id: "submissions", name: "我的发布", icon: "fa-cube" },
        { id: "points", name: "积分记录", icon: "fa-history" },
        { id: "settings", name: "账号设置", icon: "fa-cog" },
      ],
      pointRecords: [
        { action: "每日签到", change: 5, date: "2023-12-25 09:00" },
        {
          action: '发布工具 "AI 写作助手"',
          change: 50,
          date: "2023-12-24 14:30",
        },
        { action: "评论工具", change: 2, date: "2023-12-23 11:20" },
        { action: "下载工具", change: -5, date: "2023-12-22 16:45" },
        { action: "完善个人信息", change: 20, date: "2023-12-20 10:00" },
      ],
      myToolList: [],
      sendPage: 1,
      sendTotal: 0,

      pointPage: 1,
      pointTotal: 0,
      favPage: 1,
      favTotal: 0,
      favToolList: [],
      userInfo: {
        avatar: "",
        username: "",
        email: "",
        bio: "",
        currentPassword: "",
        newPassword: "",
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.user && this.user.uid;
    },
  },
  watch: {
    // 监听登录状态变化，登录状态改变时重新查询积分
    isLogin(newVal) {
      if (newVal) {
        this.fetchUserPoints();
      }
    },
  },
  mounted() {
    // 组件挂载时，如果已登录则查询积分
    if (this.isLogin) {
      this.fetchUserPoints();
    }
  },
  async created() {
    await this.initData();
  },
  methods: {
    getStatusText(status) {
      const map = {
        0: "待审批",
        1: "已上架",
        2: "已拒绝",
      };
      return map[status] || "未知状态";
    },

    checkLogin(router) {
      if (!this.isLogin) {
        ElMessageBox.confirm("需要使用当前功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
        return;
      }

      this.$axios({
        url: "aitool/user/checklogin",
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push(router);
        }
      });
    },
    async initData() {
      var favStr = await this.$aesEncrypt({
        page: this.favPage,
        pageSize: 10,
      });
      this.$axios({
        url: "aitool/user/list/fav",
        method: "POST",
        data: {
          data: favStr,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.favTotal = res.data.total;
          this.favToolList = res.data.list;
        }
      });
    },
    fetchUserPoints() {
      this.$axios({
        url: "user/integral",
      }).then((res) => {
        if (res.code == 200) {
          var points = res.data.point;
          this.$store.commit("setPoints", points);
        }
      });
    },
    logout() {
      if (confirm("确定要退出登录吗？")) {
        // this.state.logout();
        localStorage.clear();
        this.$store.commit("clearUserInfo");
        this.$router.push("/");
      }
    },
    getPointTitle(type, bizNote) {
      if (type == 1) {
        return "每日签到";
      } else if (type == 2) {
        return "下载工具";
      } else if (type == 3) {
        return "销售工具";
      }
      return bizNote;
    },
    async selectTab(id) {
      this.currentTab = id;
      if (this.currentTab === "submissions") {
        var data = await this.$aesEncrypt({
          page: this.sendPage,
          pageSize: 10,
        });
        this.$axios({
          url: "aitool/list/mine",
          method: "POST",
          data: {
            data: data,
          },
        }).then((res) => {
          this.sendTotal = res.data.total;
          this.myToolList = res.data.list;
        });
      } else if (this.currentTab === "points") {
        var dataStr = await this.$aesEncrypt({
          page: this.pointPage,
          pageSize: 10,
        });
        this.$axios({
          url: "user/integral/record",
          method: "POST",
          data: {
            data: dataStr,
          },
        }).then((res) => {
          this.pointRecords = res.data.list;
          this.pointTotal = res.data.total;
        });
      } else if (this.currentTab === "favorites") {
        var favStr = await this.$aesEncrypt({
          page: this.favPage,
          pageSize: 10,
        });
        this.$axios({
          url: "aitool/user/list/fav",
          method: "POST",
          data: {
            data: favStr,
          },
        }).then((res) => {
          this.favTotal = res.data.total;
          this.favToolList = res.data.list;
        });
      } else if (this.currentTab === "settings") {
        this.initUserInfo();
      }
    },
    pageChange(page, type) {
      if (this.currentTab === "submissions") {
        this.sendPage = page;
      } else if (this.currentTab === "points") {
        this.pointPage = page;
      } else if (this.currentTab === "favorites") {
        this.favPage = page;
      }

      this.selectTab(type);
    },
    deleteTool(tool) {
      ElMessageBox.confirm(
        `确定删除当前工具:${tool.title}么？删除后不可以恢复`,
        "删除工具",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.$axios({
            url: "aitool/" + tool.id,
            method: "DELETE",
          }).then(async (res) => {
            if (res.code == 200) {
              ElMessage({
                message: "删除成功",
                type: "success",
              });
              await this.selectTab("submissions");
            } else {
              ElMessage({
                message: res.msh,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    toggleFavorite(id) {
      this.$axios({
        url: "aitool/action/fav/" + id,
        method: "DELETE",
      }).then(async (res) => {
        if (res.code != 200) {
          ElMessage.error(res.msg);
        } else {
          await this.initData();
        }
      });
    },
    initUserInfo() {
      if (this.user) {
        this.userInfo.avatar = this.user.avatar;
        this.userInfo.username = this.user.name || this.user.username;
        this.userInfo.email = this.user.email || "techmaster@example.com"; // Mock email if missing
      }
    },
    saveSettings() {
      // Simulate API call
      ElMessage.success("个人信息保存成功");

      // Update Vuex
      if (this.$store) {
        this.$store.commit("setUserInfo", {
          ...this.user,
          name: this.userInfo.username,
          avatar: this.userInfo.avatar,
        });
      }

      // Update Global State (for Navbar)
      if (globalState && globalState.user) {
        globalState.user.username = this.userInfo.username;
        globalState.user.avatar = this.userInfo.avatar;
      }
    },

    /**
     * 触发头像上传选择框
     */
    triggerAvatarUpload() {
      this.$refs.avatarInput.click();
    },

    /**
     * 处理头像上传
     * @param {Event} e - 文件选择事件
     */
    async handleAvatarUpload(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 验证文件类型和大小
      const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
      if (!validTypes.includes(file.type)) {
        ElMessage.error("请上传 PNG、JPG、JPEG 或 WEBP 格式的图片");
        return;
      }

      // 限制文件大小为2MB
      const maxSize = 2 * 1024 * 1024; // 2MB
      if (file.size > maxSize) {
        ElMessage.error("图片大小不能超过 2MB");
        return;
      }

      // 显示加载提示
      ElMessage.info({
        message: "正在上传头像...",
        id: "avatar-upload",
      });

      try {
        // 创建FormData对象用于文件上传
        const formData = new FormData();
        formData.append("file", file);
        formData.append("UploadType", "Files");
        formData.append(
          "businessType",
          "avatar/" + new Date().format("yyyy/MM/dd"),
        );

        // 上传图片到服务器（请替换为你的实际上传接口）
        const res = await this.$axios({
          url: "upload", // 图片上传接口
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置的请求头
          },
        });

        // 假设服务器返回 { code: 200, data: { url: "https://xxx.com/xxx.jpg" } }
        if (res.code === 200) {
          console.log(JSON.stringify(res));
          var avatar = res.data.uploads.files[0].o.fullPath; // 保存服务器返回的图片URL

          var dataStr = await this.$aesEncrypt({
            uid: this.user.uid,
            avatar: avatar,
          });
          this.$axios({
            url: "user/update/avatar",
            method: "POST",
            data: {
              data: dataStr,
            },
          }).then((res) => {
            if (res.code == 200) {
              this.$store.commit("setUserInfo", {
                ...this.user,
                avatar: avatar,
              });
              // 更新本地用户信息
              this.userInfo.avatar = avatar;
            } else {
              console.error("头像上传失败");
            }
          });
        } else {
          this.uploadError = res.message || "图片上传失败";
        }
      } catch (error) {
        console.error("图片上传失败:", error);
        // ElMessage.close("avatar-upload");
        console.error("头像上传失败:", error);
        ElMessage.error("头像上传失败，请稍后重试");
      } finally {
        e.target.value = "";
        // ElMessage.close("avatar-upload");
      }
    },
  },
};
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length),
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length),
      );
  return fmt;
};
</script>

<style scoped>
.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
</style>
